export const TARGETING_RESTRICTION_TYPES = {
    UNSUPPORTED: 'UNSUPPORTED',
    UNSUPPORTED_INCLUDE: 'UNSUPPORTED_INCLUDE',
    REQUIRED: 'REQUIRED',
};
